import { render, staticRenderFns } from "./BaseRow.vue?vue&type=template&id=e54bae96&"
var script = {}
import style0 from "./BaseRow.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports